import React from 'react';
import { Star, ExternalLink } from 'lucide-react';


// ✅ The reviews array has been updated with real testimonials from your list
const reviews = [
  {
    name: 'Ramya K N',
    role: 'former Student',
    content:
      "Guru Sir has strong expertise in SAP SD and explains every concept clearly with a lot of patience. His step-by-step teaching, repeated explanations, and regular backup classes are very helpful.",
    rating: 5,
    image: 'https://c8.alamy.com/comp/2AXMG9A/letter-r-simple-circle-logo-vector-2AXMG9A.jpg',
  },
  {
    name: 'Murugesh',
    role: 'former Student',
    content:
      "This is one of the best institute to acquire the knowledge this institute. Gurunath Reddy Sir is excellent knowledge about SAP SD & S4 HANA and always strive to do his best, which inspires students to be confident and achieve their goals quickly. And it was an excellent experience, this is the best place to learn SAP SD.",
    rating: 5,
    image: 'https://lh3.googleusercontent.com/a-/ALV-UjXvxSTuNPtAHiED4g7tB-hiEd439IaVjs8Nd7_BfCxmM1-JDbzXwg=w72-h72-p-rp-mo-br100',
  },
  {
    name: 'Venkat Reddy',
    role: 'former Student',
    content:
      "Hi Everyone, we have completed SAP SD course recently and Guru sir explained each and every topic and real time scenarios. Thank you Guru Sir. Who are interested to learn SAP SD, this is the best training centre as Shreeguru cool technologies, in Marathahalli, Bangalore.",
    rating: 5,
    image: 'https://lh3.googleusercontent.com/a-/ALV-UjUsjgyTNMTdj8Ysq3wHe1nLvFifeUgLVf2P4XNShwP6-j-w8E16=w72-h72-p-rp-mo-br100',
  },
  {
    name: 'Pruthvi T',
    role: 'Former Student',
    content:"Provided in depth knowledge about SAP SD topics and real time business scenarios Good place to learn SAP for future growth. Thank you Guru Sir",
    rating: 5,
    image: 'https://lh3.googleusercontent.com/a-/ALV-UjWummVV2YrldaCsSyMFyfM2I8YmM_0_pH_akEdtXBDdYVdt4tJJXQ=w72-h72-p-rp-mo-br100',
  },
];

// ✅ 1. A helper function to shorten the review text for a cleaner look
const truncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) {
        return text;
    }
    return text.substring(0, maxLength) + '...';
};

const TestimonialsSection: React.FC = () => (
  <section className="py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">What Our Students Say</h2>
        <p className="text-gray-600 text-lg">Real feedback from our successful alumni.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {reviews.map((review, index) => (
          <div
            key={index}
            className="bg-gray-50 rounded-xl shadow-md p-6 border hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col"
          >
            <div className="flex items-center mb-4">
              {[...Array(review.rating)].map((_, i) => (
                <Star
                  key={i}
                  className="h-5 w-5 text-yellow-400"
                  fill="currentColor"
                />
              ))}
            </div>
            {/* ✅ 2. Use the truncate function to keep cards looking uniform */}
            <p className="text-gray-700 mb-5 flex-grow">"{truncateText(review.content, 150)}"</p>
            <div className="flex items-center space-x-3 mt-auto">
              <img
                src={review.image}
                alt={review.name}
                className="w-12 h-12 rounded-full object-cover border-2 border-blue-100"
              />
              <div>
                <p className="font-semibold text-gray-900">{review.name}</p>
                <p className="text-sm text-gray-600">{review.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ✅ 3. Added a "Read More Reviews" button linking to Google */}
      <div className="text-center mt-16">
        <a
          href="https://www.google.com/search?q=ShreeGuruCool+teKnologies+Reviews"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-700 transition-transform transform hover:scale-105"
        >
          Read More Reviews on Google
          <ExternalLink size={18} />
        </a>
      </div>
    </div>
  </section>
);

export default TestimonialsSection;